(ns frontend.view.modals.value-creation.view
  (:require
   [common.localization :as loc]
   [frontend.bootstrap.components :as rbs]
   [frontend.utils :as fu]
   [frontend.state.current-session :as session]
   [frontend.view.entity-viewers.activity.insider-activity :as insider-activity]
   [frontend.view.entity-viewers.events.style :as style]
   [reagent.core :as r]
   [common.schema.registry :as registry]
   [potpuri.core :as potpuri :refer [fn-> fn->>]]
   [frontend.state.permissions :as f-permissions]
   [common.util :as cu]
   [basic-components.field-editor :as field-editor]
   [common.schema.field :as field]
   [frontend.ui.component.alert.view :refer [alert]]
   [frontend.ui.component.text.view :refer [text]]
   [frontend.view.components.upload :as upload]
   [basic-components.attachments :as attachments-view]
   [clojure.set :as set]
   [frontend.view.modals.value-creation.events :as events]
   [basic-components.step-indicator :as step-indicator]
   [frontend.view.entity-viewers.events.editor-utils :as editor-utils]
   [reagent.ratom :as ratom]
   [ui.components.button.view :as button]
   [ui.components.select.select :as select]
   [ui.components.modal.style :as modal-style]
   [ui.components.modal.view :as modal]
   [ui.components.radix-ui.popover.view :as popover]))

(defonce modal-key :value-creation-modal)

(defn resolve-activity-template
  [{:keys [raw-schema editable-id entity-type parent-entity-type]}]
  (let [holding-attributes [:value-creation/execution-year
                            :value-creation/results
                            :value-creation/help-needed
                            :value-creation/help-needed-description
                            :value-creation/holding-category
                            :value-creation/holding-subcategory
                            :value-creation/holding-our-managers-role
                            :value-creation/our-manager]
        investor-attributes [:value-creation/date-execution-date
                             :value-creation/target
                             :value-creation/investor-maturity
                             :value-creation/investor-categories
                             :value-creation/investor-subcategories
                             :value-creation/agm-and-advisory-boards
                             :value-creation/investor-our-managers-role
                             :value-creation/our-managers
                             :value-creation/opt-17592200887814-esg-development-plan-topic]]
    (some->>
     raw-schema
     (remove (fn [[attribute field-schema]]
               (or (editor-utils/no-related-entities? attribute)
                   (editor-utils/guest-and-not-allowed-field? attribute)
                   (not (f-permissions/field-write-access? attribute entity-type nil))
                   (->> field-schema
                        :field/default-visibility
                        :editor
                        (= :editor.type/none))
                   (->> field-schema
                        :field/default-visibility
                        :field-visibility
                        (= :not-in-use)))))
     (map (fn [[attribute field-schema]]
            (merge field-schema
                   {:attribute   attribute
                    :access/type (if editable-id
                                   (f-permissions/access-to-field-long attribute entity-type nil)
                                   :field.access/write)
                    :editor/type (->> field-schema
                                      :field/default-visibility
                                      :editor)})))
     (cu/remove-by :editor/type :editor.type/none)
     (remove :field/secondary-field?) ;; secondary fields are shown in related fields in editor
     (remove (fn [field-schema]
               (cond (= :entity.type/investor parent-entity-type)
                     (some #{(:attribute field-schema)} holding-attributes)
                     (= :entity.type/holding parent-entity-type)
                     (some #{(:attribute field-schema)} investor-attributes)
                     :else
                     nil)))
     (remove (fn [field-schema]
               (= (:attribute field-schema) :value-creation/parent-entity))))))

(defn resolve-value
  [{:keys [aggregate-attribute particular-value entity-atom attribute updates-atom]}]
  (if (and aggregate-attribute (fn? particular-value))
    (set (particular-value (events/get-value entity-atom updates-atom aggregate-attribute)
                           session/get-entity))
    (events/get-value entity-atom updates-atom attribute)))

(defn index-to-render-menu-dropdown-top
  [field-count]
  (- field-count 2))

(defn associations-view
  [{:keys [parent-entity-id state aggregated-fields-schema entity-atom updates-atom]}]
  (let [field-count (count aggregated-fields-schema)]
    [:div
     [:div.mb-4
      [alert
       {:variant :info}
       [:span
        [text (loc/tr :value-creation-associations-info)]]]]
     (let [attribute :value-creation/parent-entity
           field-schema (registry/get-field-schema @session/tenant-schema attribute)
           value (get @updates-atom
                      attribute
                      (get @entity-atom attribute))
           value-entity (session/get-entity value)
           field-schema
           (assoc field-schema
                  :access/type
                  (f-permissions/access-to-field-long attribute :entity.type/value-creation nil)
                  :editor/type (->> field-schema
                                    :field/default-visibility
                                    :editor)
                  :field/entity-types [(:entity/type value-entity)])]
       [:div.select-area.mb-3
        [field-editor/view
         (merge field-schema
                {:menu-placement    "auto"
                 :attribute         attribute
                 :id                (str "field-editor" parent-entity-id "-" attribute)
                 :state-atom        state
                 :value             value
                 :containing-entity @entity-atom
                 :close-menu-on-scroll? true
                 :create-on-fly?    true
                 :menu-portal-target (.getElementById js/document "react-select-menu-container")
                 :read-only?        (not (some #{(:access/type field-schema)}
                                               [:field.access/write :field.access/create]))
                 :entity-types-atom session/entity-types
                 :label             (loc/tr :value-creation-change-parent-entity-label
                                        [(loc/tr (:entity/type value-entity))])
                 :mandatory?        false
                 :placeholder       (field/placeholder field-schema)
                 :tools             [:tool-item/cancel]
                 :error-text        nil ;; TODO: use editor-atom to store validation and save errors
                 :on-save!          (fn [attribute editor-new-value on-success! on-error!]
                                      (let [save-attribute attribute

                                            old-attribute-value (events/get-value entity-atom
                                                                                  updates-atom
                                                                                  save-attribute)]
                                        (if (or (= editor-new-value old-attribute-value)
                                                (and (fu/empty-value? editor-new-value)
                                                     (fu/empty-value? old-attribute-value)))
                                          ;; no changes ->> OK
                                          (do
                                            (on-success!))
                                          (do
                                            (swap! updates-atom assoc attribute editor-new-value)
                                            (deref updates-atom)
                                            (when on-success!
                                              (on-success!))))))})]])
     (->>
      aggregated-fields-schema
      (map-indexed
       (fn [idx
            {:keys [attribute field/aggregate-attribute field/particular-value]
             :as   field-schema}]
         (let [value (resolve-value {:aggregate-attribute aggregate-attribute
                                     :particular-value    particular-value
                                     :entity-atom         entity-atom
                                     :attribute           attribute
                                     :updates-atom        updates-atom})]
           ^{:key (str "field-editor" parent-entity-id "-" attribute)}
           [:div.select-area.mb-3
            [field-editor/view
             (merge
              field-schema
              {:menu-placement
               (if (>= idx (index-to-render-menu-dropdown-top field-count)) "top" "auto")
               :id                (str "field-editor" parent-entity-id "-" aggregate-attribute)
               :state-atom        state
               :value             value
               :containing-entity @entity-atom
               :close-menu-on-scroll? true
               :create-on-fly?    true
               :menu-portal-target (.getElementById js/document "react-select-menu-container")
               :read-only?        (not (some #{(:access/type field-schema)}
                                             [:field.access/write :field.access/create]))
               :entity-types-atom session/entity-types
               :label             (or (->> field-schema
                                           :field/translations
                                           :en)
                                      (loc/tr attribute)
                                      (when-let [fs (registry/get-field-schema
                                                     @session/tenant-schema
                                                     attribute)]
                                        (loc/field-name attribute fs))) ;; we select label outside the field-editor, so we can customize label if needed
               :mandatory?        false
               :placeholder       (field/placeholder field-schema)
               :tools             [:tool-item/cancel]
               :error-text        nil ;; TODO: use editor-atom to store validation and save errors
               :on-save!
               (fn [attribute editor-new-value on-success! on-error!]
                 (let [save-attribute aggregate-attribute
                       old-attribute-value
                       (events/get-value entity-atom updates-atom save-attribute)
                       edited-value (let [new-value (set editor-new-value)
                                          old-value (resolve-value
                                                     {:aggregate-attribute aggregate-attribute
                                                      :particular-value    particular-value
                                                      :entity-atom         entity-atom
                                                      :attribute           attribute
                                                      :updates-atom        updates-atom})
                                          added-values (set/difference new-value old-value)
                                          removed-values (set/difference old-value new-value)
                                          old-aggregate-value old-attribute-value]
                                      (-> old-aggregate-value
                                          (set/union added-values)
                                          (set/difference removed-values)))]
                   (if (or (= edited-value old-attribute-value)
                           (and (fu/empty-value? edited-value)
                                (fu/empty-value? old-attribute-value)))
                     ;; no changes ->> OK
                     (do
                       (on-success!))
                     (do
                       (swap! updates-atom assoc :common/related-entities edited-value)
                       (deref updates-atom)
                       (when on-success!
                         (on-success!))))))})]])))
      (doall))]))

(defn editor-view
  [{:keys [state filtered-schema parent-entity
           parent-entity-id entity-atom
           mandatory-fields updates-atom]}]
  (let [schema (->> filtered-schema
                    (remove :field/aggregate-attribute))
        field-count (count schema)]
    [:div
     (->> schema
          (map-indexed
           (fn [idx
                {:keys [attribute]
                 :as   field-schema}]
             (let [value (events/get-value entity-atom updates-atom attribute)]
               ^{:key (str "field-editor" parent-entity-id "-" attribute)}
               [:div.mb-2
                [field-editor/view
                 (merge
                  field-schema
                  {:menu-placement    (if (>= idx (index-to-render-menu-dropdown-top field-count))
                                        "top"
                                        "auto")
                   :id                (str "field-editor" parent-entity-id "-" attribute)
                   :state-atom        state
                   :value             value
                   :containing-entity parent-entity
                   :close-menu-on-scroll? true
                   :menu-portal-target (.getElementById js/document "react-select-menu-container")
                   :create-on-fly?    (session/is-admin?)
                   :read-only?        (not (some #{(:access/type field-schema)}
                                                 [:field.access/write :field.access/create]))
                   :entity-types-atom session/entity-types
                   :label             (or (->> field-schema
                                               :field/translations
                                               :en)
                                          (loc/tr attribute)
                                          (when-let [fs (registry/get-field-schema
                                                         @session/tenant-schema
                                                         attribute)]
                                            (loc/field-name attribute fs))) ;; we select label outside of field-editor so we can customize label if needed
                   :mandatory?        (some #{attribute} mandatory-fields)
                   :placeholder       (field/placeholder field-schema)
                   :tools             [:tool-item/cancel]
                   :error-text        nil ;; TODO: use editor-atom to store validation and save errors
                   :on-save!          (fn [attribute editor-new-value on-success! on-error!]
                                        (let [save-attribute attribute
                                              old-attribute-value (events/get-value entity-atom
                                                                                    updates-atom
                                                                                    attribute)
                                              edited-value editor-new-value]
                                          (if (or (= edited-value old-attribute-value)
                                                  (and (fu/empty-value? edited-value)
                                                       (fu/empty-value? old-attribute-value)))
                                            ;; no changes ->> OK
                                            (do
                                              (on-success!))
                                            (do
                                              (swap! updates-atom assoc save-attribute edited-value)
                                              (deref updates-atom)
                                              (when on-success!
                                                (on-success!))))))}
                  (when (= attribute :value-creation/status)
                    {:field/custom-sort true
                     :options (->> (:options field-schema)
                                   (map-indexed (fn [index option]
                                                  (assoc option :common/ord index))))}))]])))
          (doall))
     (when (session/insider-groups?)
       (let [insider-groups (->> @session/all-insider-groups
                                 (remove :common/disabled?))
             active-insider-groups (->> insider-groups
                                        (cu/filter-by :insider-group/status :insider-group.status/active)
                                        (seq))]
         (when active-insider-groups
           (let [selected-group-id (events/get-value entity-atom updates-atom :common/insider-group)
                 selected-group (session/get-entity selected-group-id)
                 options (->> active-insider-groups
                              (map (fn [ai]
                                     {:value (:db/id ai)
                                      :label (:insider-group/name ai)}))
                              (sort-by :label)
                              (vec))]
             [:div
              {:class "flex flex-col gap-1 pl-4 pr-0"}
              [:label
               {:class "mb-0 font-bold text-sm"}
               (loc/tr :common/insider-group)]
              [select/view
               {:value     (->> options
                                (cu/filter-by :value selected-group-id)
                                (first))
                :is-clearable? true
                :on-change (fn [val]
                             (swap! updates-atom assoc :common/insider-group val)
                             (deref updates-atom))
                :options options}]
              (when selected-group
                [popover/view
                 {:open? (:popover-open? @state)
                  :on-open-change (fn [open?]
                                    (swap! state assoc :popover-open? open?))}
                 [:div
                  {:class "text-base-light-text-accent underline font-bold"}
                  (loc/tr :show-insiders)]
                 [insider-activity/popup-view selected-group-id]])]))))
    ]))

;;combined max 50 MB:
(def MAX-ATTACHMENT-SIZE (* 50 1024 1024))

(defn attachments-view
  [{:keys [state entity-atom entity-id updates-atom]}]
  (let [entity (get @session/entities entity-id)
        attachments (->> entity
                         :common/attachments
                         (keep (fn->> (get @session/entities)))
                         (remove :common/disabled?)
                         (sort-by :common/created-on)
                         reverse)
        common-attachments (set attachments)
        current-attachments-size (->> common-attachments
                                      (map :attachment/content-length)
                                      (filter number?)
                                      (apply +))
        pending-attachments-size (->> @state
                                      :uploading
                                      (map :size)
                                      (filter number?)
                                      (apply +))
        total-attachments-size (+ current-attachments-size
                                  pending-attachments-size)
        on-success! (fn [body]
                      (let [old-attachments
                            (events/get-value entity-atom updates-atom :common/attachments)
                            new-attachments (if (seq old-attachments)
                                              (conj old-attachments (:db/id body))
                                              #{(:db/id body)})]
                        (swap! updates-atom assoc :common/attachments new-attachments)))]
    [:div.attachment-selectors__upload-zone.pt-3
     [:div.mb-3
      [alert
       {:variant :info}
       [:span
        [text (loc/tr :attachments-value-creation-info)]]]]
     [upload/custom-upload-zone
      {:class-name "value-creation-upload-zone"
       :on-change! (fn [{:keys [files original-event] :as args}]
                     (let [size (->> (aget files 0)
                                     (.-size))
                           new-size (+ (or size 0)
                                       total-attachments-size)]
                       (if (> new-size MAX-ATTACHMENT-SIZE)
                         (swap! state assoc :error (loc/tr :max-combined-attachment-size-error))
                         (events/add-attachment-to-entity! {:db/id       entity-id
                                                            :state       state
                                                            :on-success! on-success!
                                                            :on-error!   identity}
                                                           args))
                       (set! (-> original-event
                                 .-target
                                 .-value)
                             "")))
       :accept     ".jpg, .jpeg, .png, .pdf"}]
     [attachments-view/attachments-error state]
     [:div.attachment-listing.mb-3
      (doall
       (for [indicator (:uploading @state)]
         ^{:key (str "uploading-attachment-" (:token indicator))}
         [attachments-view/indicator-view state indicator]))
      (doall
       (for [attachment attachments]
         ^{:key (str "attachment-" (:db/id attachment))}
         [attachments-view/attachment-view-with-remove attachment entity-id nil]))]]))

(defn resolve-selected-view
  [state]
  (let [selected-view (-> @state
                          :modal-step)
        selected-view (or selected-view
                          :associations-view)]
    selected-view))

(defn editor-view-step
  []
  [:span.d-flex.justify-content-center.align-items-center
   [:div.state-indicator__text.d-flex.flex-column.justify-content-start.text-left
    [:div (loc/tr :step-n-n [1 3])]]])

(defn associations-view-step
  []
  [:span.d-flex.justify-content-center.align-items-center
   [:div.state-indicator__text.d-flex.flex-column.justify-content-start.text-left
    [:div (loc/tr :step-n-n [2 3])]]])

(defn attachments-view-step
  []
  [:span.d-flex.justify-content-center.align-items-center
   [:div.state-indicator__text.d-flex.flex-column.justify-content-start.text-left
    [:div (loc/tr :step-n-n [3 3])]]])

(defn view
  [{:keys [shown? close-modal! props state class-name topmost?]}]
  (let [{:keys [containing-entity-id entity-id entity on-save-success! delete-entity!]} props
        containing-entity (session/get-entity containing-entity-id)
        associations @(r/track fu/get-entity-associations containing-entity-id)
        associated-entity-ids (->> associations
                                   (map (fn [association]
                                          (let [te (:entity-association/target-entity association)
                                                se (:entity-association/source-entity association)]
                                            (if (= te containing-entity-id)
                                              se
                                              te))))
                                   (set))
        entity-atom (ratom/reaction
                     (let [value-creation-id (or entity-id (:value-creation-id @state))]
                       (if (and value-creation-id (not entity))
                         (session/get-entity value-creation-id)
                         entity)))
        updates-atom (r/atom {})
        steps [{:key     :editor-view
                :content [editor-view-step]}
               {:key     :associations-view
                :content [associations-view-step]}
               {:key     :attachments-view
                :content [attachments-view-step]}]]
    (swap! state assoc :modal-step :editor-view)
    (when-not entity-id
      (events/create-value-creation!
       {:state        state
        :parent-entity-id containing-entity-id
        :related-entities (set/union
                           ;associated-entity-ids
                           #{containing-entity-id}
                           (when-let [asset-id (:holding/target-asset containing-entity)]
                             #{asset-id})
                           (when-let [legal-entity-id (:investor/legal-entity containing-entity)]
                             #{legal-entity-id})
                           (when associated-entity-ids
                             associated-entity-ids))
        :close-modal! close-modal!}))
    (fn [{:keys [shown? close-modal! props state class-name topmost?]}]
      (let [{:keys [containing-entity-id]} props
            modal-step (:modal-step @state)
            editor-view? (= :editor-view modal-step)
            attachments-view? (= :attachments-view modal-step)
            existing-entity (session/get-entity entity-id)
            parent-entity-id (if entity-id
                               (:value-creation/parent-entity existing-entity)
                               containing-entity-id)
            parent-entity (session/get-entity parent-entity-id)
            parent-entity-type (:entity/type parent-entity)
            schema (registry/get-schema @session/tenant-schema :entity.type/value-creation)
            selected-view (resolve-selected-view state)
            filtered-schema (resolve-activity-template
                             {:raw-schema         schema
                              :entity-id          parent-entity
                              :entity-type        :entity.type/value-creation
                              :parent-entity-type parent-entity-type})
            aggregated-fields-schema (->> filtered-schema
                                          (filter (fn [field-schema]
                                                    (:field/aggregate-attribute field-schema))))
            ordered-fields (if (= parent-entity-type :entity.type/investor)
                             events/ordered-investor-fields
                             events/ordered-holding-fields)
            ordered-count (count ordered-fields)
            ordered-schema
            (->> filtered-schema
                 (map-indexed (fn [idx field-schema]
                                (let [attribute (:attribute field-schema)
                                      ordered-attribute
                                      (->> ordered-fields
                                           (filter (fn [field]
                                                     (= (:attribute-key field) attribute)))
                                           (first))]
                                  (if-let [ord (get ordered-attribute :ord nil)]
                                    (assoc field-schema :ord ord)
                                    (assoc field-schema :ord (+ ordered-count idx))))))
                 (doall)
                 (sort-by :ord))
            mandatory-fields (events/mandatory-fields parent-entity-type)
            empty-associations?
            (empty? (events/get-value entity-atom updates-atom :common/related-entities))
            some-mandatory-fields-empty?
            (->> mandatory-fields
                 (some (fn [field]
                         (let [value (events/get-value entity-atom updates-atom field)]
                           (fu/empty-value? value)))))
            value-creation-id (or entity-id (:value-creation-id @state))
            next-button-disabled? (if editor-view?
                                    some-mandatory-fields-empty?
                                    empty-associations?)
            next-button-tooltip-text (if editor-view?
                                       (loc/tr :please-fill-in-all-mandatory-fields)
                                       (loc/tr :add-association-disabled-tooltip))
            on-close! (fn [_]
                        (events/close-modal! {:entity-id         entity-id
                                              :close-modal!      close-modal!
                                              :value-creation-id value-creation-id
                                              :state             state
                                              :entity-atom       entity-atom}))
            on-save-success! (fn [_]
                               (close-modal!)
                               (when (fn? on-save-success!)
                                 (on-save-success!)))]
        [modal/view
         {:visible?      (and shown? topmost?)
          :hide!         on-close!
          :backdrop      "static"
          :close-button? true}
         (if entity-id
           (loc/tr :value-creation-edit)
           (loc/tr :value-creation-create))
         [:<>
          [:div.d-flex.justify-content-center.mb-3
           [step-indicator/view
            {:current-step selected-view
             :steps        steps}]]
          (cond
            editor-view?
            [editor-view
             {:state            state
              :filtered-schema  ordered-schema
              :entity-atom      entity-atom
              :parent-entity    parent-entity
              :parent-entity-id parent-entity-id
              :mandatory-fields mandatory-fields
              :updates-atom     updates-atom}]
            attachments-view?
            [attachments-view
             {:state        state
              :entity-id    value-creation-id
              :entity-atom  entity-atom
              :updates-atom updates-atom}]
            :else
            [associations-view
             {:parent-entity-id parent-entity-id
              :state            state
              :entity-atom      entity-atom
              :updates-atom     updates-atom
              :aggregated-fields-schema aggregated-fields-schema}])]
         [:<>
          [modal/left-cancel-only on-close! nil]
          [:div
           {:class "flex justify-end flex-1 items-center gap-3"}
           (when (fn? delete-entity!)
             [button/danger-solid
              {:on-click (fn [_]
                           (close-modal!)
                           (delete-entity!))}
              (loc/tr :delete)])
           (when-not editor-view?
             [button/secondary-hollow
              {:on-click (fn [_]
                           (events/go-back! state))}
              (loc/tr :back)])

           (when-not attachments-view?
             [button/primary-solid
              {:disabled? next-button-disabled?
               :tooltip   next-button-tooltip-text
               :on-click  #(events/go-to-the-next-step! state)}
              (loc/tr :next)])

           (when attachments-view?
             [button/primary-solid
              {:on-click (fn [_]
                           (swap! state assoc :processing? true)
                           (events/save-changes!
                            {:state             state
                             :value-creation-id value-creation-id
                             :close-modal!      on-save-success!
                             :updates-atom      updates-atom}))}
              (if (:processing? @state)
                [:span.zap-button--spinner-wrapper
                 [:img.zap-button--spinner
                  {:src "/img/spinner.svg"}]
                 (loc/tr :saving)]
                (loc/tr :save))])]]]))))
